



























































import { Component, Vue } from 'vue-property-decorator';
import { mdiImageMultiple } from '@mdi/js';

@Component
export default class Home extends Vue {
  
  private icons = { mdiImageMultiple };

}
